
var ReactDOM = require('react-dom');
var React = require('react');
import {VoltCountryBankSelect} from "./VoltCountryBankSelect";

export class VoltCountryBankSelectContainer {
    constructor(paymentMethodSelect, paymentMethodId, countries, banks, country, bank) {
        const domContainer = document.querySelector('#volt-payment');
        ReactDOM.render(
            <VoltCountryBankSelect paymentMethodId={paymentMethodId} paymentMethodSelect={paymentMethodSelect} countries={countries} banks={banks} country={country} bank={bank} />, 
            domContainer
        );
    }
}

